export default "__VITE_ASSET__LqZLZ7da__"